import {
  confirmPasswordReset,
  isSignInWithEmailLink,
  sendPasswordResetEmail,
  sendSignInLinkToEmail,
  signInWithEmailLink,
  signInWithEmailAndPassword,
  signOut,
} from 'firebase/auth';
import { auth } from '../firebase';

const actionCodeSettings = {
  url: window.location.origin,
  handleCodeInApp: true,
};

class AuthService {
  async login(email: string) {
    await sendSignInLinkToEmail(auth, email, actionCodeSettings);
    window.localStorage.setItem('emailForSignIn', email);
  }

  async loginWithPassword(email: string, password: string) {
    const result = await signInWithEmailAndPassword(auth, email, password);
    return result.user;
  }

  async completeLogin(email: string, emailLink: string) {
    if (isSignInWithEmailLink(auth, emailLink)) {
      const result = await signInWithEmailLink(auth, email, emailLink);
      window.localStorage.removeItem('emailForSignIn');
      return result.user;
    }
    throw new Error('Invalid sign-in link');
  }

  async logout() {
    return signOut(auth);
  }

  async forgotPassword(email: string) {
    await sendPasswordResetEmail(auth, email, actionCodeSettings);
  }

  async resetPassword(oobCode: string, newPassword: string) {
    await confirmPasswordReset(auth, oobCode, newPassword);
  }
}

export const authService = new AuthService();
